import React from 'react';
import styled from 'styled-components';

export const Colors = styled.ul<{ small?: boolean }>`
    display: flex;
    flex-wrap: wrap;
    gap: 5px;
    margin: 0;
    padding: 0;
    list-style: none;

    ${(props) =>
        props.small &&
        `
        grid-template-columns: repeat(auto-fill, minmax(18px, 1fr));
    `}
`;

export const Color = styled.li<{
    color: string;
    $hoverable?: boolean;
    small?: boolean;
}>`
    width: 26px;
    height: 26px;
    border-radius: 50%;
    border: 1px solid #ddd;
    background: ${(props) => props.color};

    ${(props) =>
        props.small &&
        `
        width: 18px;
        height: 18px;
    `}

    ${(props) =>
        props.$hoverable &&
        `
        cursor: pointer;

        @media(hover) {
            &:hover {
                opacity: 0.7;
            }
        }
    `}
`;

const EmptyColorContainer = styled.div`
    position: relative;
`;

const EmptyColorStripe = styled.div`
    width: 25px;
    height: 3px;
    background-color: red;
    transform: rotate(-45deg);
    position: absolute;
    top: 11px;
    left: 0px;
`;

export const EmptyColor = () => (
    <EmptyColorContainer>
        <EmptyColorStripe />
    </EmptyColorContainer>
);
